import classNames from 'classnames';
import AnimatedTitle from '../../../components/AnimatedTitle';
import Img from '../../../components/Img';
import styles from './Article.module.scss';

export type BlockquoteProps = {
  text: string,
  author?: {
    name: string,
    position: string,
  },
  authorName?: string,
  authorPosition?: string,
  authorImage?: string,
};
const Blockquote = ({
  text, author, authorName, authorPosition, authorImage,
}: BlockquoteProps) => (
  <figure className={styles.blockquote}>
    <div className={styles.visual}>
      <div className={styles.line} />
      <svg className={styles.icon}>
        <use
          xlinkHref='/media/quote.svg#quoteSVG'
          href='/media/quote.svg#quoteSVG'
        />
      </svg>
      <div className={styles.line} />
    </div>
    <blockquote className={classNames(styles.blockquoteText, 'bodyLarge')}><AnimatedTitle title={text} /></blockquote>
    {author ? (
      <figcaption>
        <cite className={styles.authorName}>{author.name}</cite>
        <p className={styles.authorPosition}>{author.position}</p>
      </figcaption>
    ) : (
      <figcaption className={styles.authorInfo}>
        {authorImage && (
          <Img
            src={authorImage}
            alt='particles'
            className={styles.authorImage}
            width={48}
            height={48}
          />
        )}
        <div>
          <cite className={styles.authorName}>{authorName}</cite>
          <p className={styles.authorPosition}>{authorPosition}</p>
        </div>
      </figcaption>
    )}
    <div className={styles.ellipse} />
  </figure>
);

export default Blockquote;
